<div [formGroup]="form">
  <select class="form-control" formControlName="swotType">
    <option value="" style="display: none;" selected="selected"></option>
    <option *ngFor="let swot of swotTypes" value="{{ swot }}">{{ swot | translate }}</option>
  </select>
</div>